export default __webpack_public_path__ + "static/data-unions-be11b9222e99d7c0af1a9b718f082812.png";